import type { CollectionCreatorPageModelState } from './types';

export const initialState: CollectionCreatorPageModelState = {
  userInfo: null,

  step: 1,

  step1_resourceType: null,
  step1_resourceType_errorText: '',
  step1_resourceTitle: '',
  step1_resourceTitle_errorText: '',
  step1_resourceName: '',
  step1_resourceName_optimized: '',
  step1_resourceName_isVerify: false,
  step1_resourceName_errorText: '',
  step1_createdResourceInfo: null,
  step1_dataIsDirty_count: 0,

  step2_resourceTypeConfig: {
    uploadEntry: [],
    limitFileSize: 0,
    isSupportDownload: false,
    isSupportEdit: false,
    isSupportOptionalConfig: false,
  },
  step2_collectionItemsSetting: {
    collection_sort_list: 'collection_sort_ascending',
    collection_item_title: 'collection_item_title_rtitle',
    collection_item_no_display: 'collection_item_no_display_show',
    collection_item_image_display: 'collection_item_image_display_show',
    collection_item_descr_display: 'collection_item_descr_display_show',
    collection_view: 'collection_view_list',
  },
  step2_resourceKeywords: '',
  step2_resources: [],
  step2_resources_state: 'noData',
  step2_resources_totalCount: 0,
  step2_resources_pageCurrent: 1,
  step2_resources_pageSize: 10,
  step2_systemProperties: [],
  step2_customProperties: [],
  step2_customConfigurations: [],

  step2_directDependencies: [],
  step2_baseUpcastResources: [],
  step2_authExcludedItems: [],
  step2_isCompleteAuthorization: true,
  step2_authReload: 0,

  step2_draftSaving: false,
  step2_draftSaveTime: '',
  step2_collectionItemsChanged: false,
  step2_otherChanged: false,
  step2_rssImportProcessing: false,

  step3_policies: [],

  step4_resourceCover: '',
  step4_resourceIntroduction: '',
  step4_updateSetting: {
    isFinish: false,
    automatic: false,
    conditionType: 'every',
    conditions: [],
  },
  step4_resourceLabels: [],
  step4_dataIsDirty_count: 0,
};
